// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/components.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/media_width_200.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/media_width_390.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/media_width_768.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/media_width_1024.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/media_width_1300.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/media_height_200.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/media_height_500.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/media_height_720.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./scss/media_height_1024.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/home-bg1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/home-bg2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/home-bg3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./images/face1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./images/face2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./images/face3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./images/midarrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./images/leftarrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./images/rightarrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./images/midarrow2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./images/leftarrow2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./images/rightarrow2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./images/recommendation-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#root {
    overflow: hidden;
    font-family: 'Manrope';
    background: #EEE !important;
}
/*#navbarToggle {*/
/*    background-color: #EFEFEF;*/
/*}*/
.white, .white a {
    color: #fff;
}
.page-content {
    overflow: hidden;
    background-color: #EFEFEF;
    font-family: 'Manrope';
}
#page .navbar {
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.512715) 61.57%, rgba(255, 255, 255, 0) 100%) !important;
    --bs-navbar-padding-x: 0 !important;
}

.main {
  height: 92vh!important;
  width: 100vw;
  overflow: hidden;
  position: relative;
}
.main-container {
  height: 100%;
  width: 100%;
  position: absolute;
    filter: blur(64px);
    -webkit-filter: blur(64px);

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    transform: scale(1.1);
}
.main .face1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.main .face2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.main .face3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.effect-bg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(252, 137, 118, 0.25) 0%, rgba(242, 67, 136, 0.25) 100%);
    mix-blend-mode: overlay;
}

.face1, .face2, .face3 {
  transition: opacity 1s ease-in-out;

}
@keyframes faceFadeInOut {
 0% {opacity: 0;}
 20% {opacity: 1;}
 33% {opacity: 1;}
 53% {opacity: 0;}
 100% {opacity: 0;}
}

.face1,.face2,.face3 {
 animation: faceFadeInOut 9s infinite;
}
.face1 {
    animation-delay: 0s;
    opacity:1;
}
.face2 {
    animation-delay: 3s;
    opacity:0;
}
.face3 {
    animation-delay: 6s;
    opacity:0;
}

.face1-container {
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
   z-index: 1;
}
.face2-container {
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
   z-index: 1;
}
.face3-container {
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
   z-index: 1;
}
.find-container{
    z-index: 2;
}
.find-container input {
    border-radius: 2rem;
    padding: 15px;
}

.arrow-container .left-label, .arrow-container .right-label{
    position: absolute;
    height: 1px;

    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 148%;
    /* or 18px */
    display: flex;
    align-items: center;
    text-align: right;
    letter-spacing: 0.02em;
    color: #FFFFFF;
    z-index: 2;
}
.arrow-container .left-label {
    right:10px;
}
.arrow-container .right-label {
    left: 20px;
    width: 100px;
}
.arrow-container .mid-arrow {
   display: block;
   height: 2px;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
}
.arrow-container .left-arrow {
   display: block;
   width:25px;
  height:25px;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
}
.arrow-container .right-arrow {
   display: block;
   width:25px;
   height:25px;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
}

.home-title {

    font-style: normal;
    text-align: center;
    letter-spacing: -0.02em;
    text-transform: lowercase;
    color: #FFFFFF;
}
.navbar {
   --bs-border-radius: 2rem;
    --bs-navbar-padding-x: 1.5rem!important;
    --bs-navbar-padding-y: 1.5rem!important;
    z-index:10;
}
.navbar .navbar-brand {

    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    line-height: 125%;
    /* or 25px */

    letter-spacing: 0.01em;
    text-transform: lowercase;

    /* Dark */

    color: #2C262F;
}
.navbar .navbar-nav li {
    padding: 0 35px;

    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 148%;

    text-transform: lowercase;

    /* Inside auto layout */
    flex: none;
    order: 2;
    flex-grow: 0;
}
.navbar .navbar-collapse {
    flex-basis: 50%;
}
.about .faceless .title {
    font-style: normal;
    color: #FF855E;
}
.about .about-msg {

    font-style: normal;
    margin-bottom: 50px;
    color: #4A444C;
}
.about .ico {
    width: 32px;
    height: 32px;
}
.about .figure {
    width: 200px;
    height: 240px;
    position: relative;
}
.about .figure .illustration {
    position: absolute;
    width: 120px;
    height: 120px;
    left: 80px;
    top: 0px;
}
.about .figure .label {
    position: absolute;
    width: 182px;
    height: 36px;
    left: 20px;
    top: 168px;
    display: inline-block;

    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 148%;
    letter-spacing: 0.02em;
    color: #4A444C;
}

.about .figures {
    display: inline;
}
.about .hireworkers {
padding-top:25px;
}
.about .hireworkers .title {
    font-style: normal;
    color: #2C262F;
    margin-bottom: 40px;
}
.about .hireworkers .desc {
    font-style: normal;
    color: #4A444C;
    width: 264px;
    height: 300px;
}
.about .hireworkers .desc .br{
    height:40px;
}

.arrow2-container {
    margin-left: auto;
    margin-right: auto;
}
.arrow2-container .left-label2, .arrow2-container .right-label2{
    position: absolute;
    height: 1px;
    display: flex;
    align-items: center;
    text-align: right;
    letter-spacing: 0.02em;
    color: #FFFFFF;
}

.arrow2-container .mid-arrow2 {
   display: block;
   height: 2px;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
   margin-top: 1px;
}
.arrow2-container .left-arrow2 {
   display: block;
   width:25px;
   height:25px;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
}
.arrow2-container .right-arrow2 {
   display: block;
   width:25px;
   height:24px;
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
}
.arrow2-container img {
    width: 53.42px;
    height: 48px;
}

.about .recommendation {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: linear-gradient(0deg, rgba(44, 38, 47, 0.8), rgba(44, 38, 47, 0.8)),  url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    color: #FFFFFF;
}
.about .recommendation .desc {
    font-style: normal;
    margin-top: 25px;
    margin-bottom: 25px;
}
.about .recommendation .desc .br{
    height:40px;
}
.about .recommendation .form{
    background: #FFFFFF;
    border-radius: 40px;
}
.about .recommendation .form .title{
    color: #2C262F;
}
.about .join .form .title{
    color: #2C262F;
}
.about .join .links a{
    text-transform: lowercase;
    color: #4A444C;
    text-decoration: none;
    overflow: hidden;
}
.about .social-link img{
   border-radius: 80px;
   height: 48px;
   width: 48px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;AAC/B;AACA,kBAAkB;AAClB,iCAAiC;AACjC,IAAI;AACJ;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,6HAA6H;IAC7H,mCAAmC;AACvC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;IAChB,kBAAkB;IAClB,0BAA0B;;IAE1B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,qBAAqB;AACzB;AACA;EACE,yDAA8C;AAChD;AACA;EACE,yDAA8C;AAChD;AACA;EACE,yDAA8C;AAChD;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gGAAgG;IAChG,uBAAuB;AAC3B;;AAEA;EAIE,kCAAkC;;AAEpC;AASA;CACC,IAAI,UAAU,CAAC;CACf,KAAK,UAAU,CAAC;CAChB,KAAK,UAAU,CAAC;CAChB,KAAK,UAAU,CAAC;CAChB,MAAM,UAAU,CAAC;AAClB;;AAEA;CAEE,oCAAoC;AACtC;AACA;IACI,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;GACG,yDAA2C;GAC3C,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;GACtB,UAAU;AACb;AACA;GACG,yDAA2C;GAC3C,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;GACtB,UAAU;AACb;AACA;GACG,yDAA2C;GAC3C,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;GACtB,UAAU;AACb;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;;IAEX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;GACG,cAAc;GACd,WAAW;GACX,yDAA8C;GAC9C,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;AACzB;AACA;GACG,cAAc;GACd,UAAU;EACX,WAAW;GACV,yDAA+C;GAC/C,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;AACzB;AACA;GACG,cAAc;GACd,UAAU;GACV,WAAW;GACX,yDAAgD;GAChD,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;AACzB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;AACA;GACG,wBAAwB;IACvB,uCAAuC;IACvC,uCAAuC;IACvC,UAAU;AACd;AACA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,sBAAsB;IACtB,yBAAyB;;IAEzB,SAAS;;IAET,cAAc;AAClB;AACA;IACI,eAAe;;IAEf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,yBAAyB;;IAEzB,uBAAuB;IACvB,UAAU;IACV,QAAQ;IACR,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,UAAU;IACV,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,UAAU;IACV,qBAAqB;;IAErB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;AACA,gBAAgB;AAChB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;AACjB;AACA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;GACG,cAAc;GACd,WAAW;GACX,yDAA+C;GAC/C,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;GACtB,eAAe;AAClB;AACA;GACG,cAAc;GACd,UAAU;GACV,WAAW;GACX,0DAAgD;GAChD,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;AACzB;AACA;GACG,cAAc;GACd,UAAU;GACV,WAAW;GACX,0DAAiD;GACjD,2BAA2B;GAC3B,4BAA4B;GAC5B,sBAAsB;AACzB;AACA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,gIAA6H;IAC7H,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;AACA;GACG,mBAAmB;GACnB,YAAY;GACZ,WAAW;AACd","sourcesContent":["\n#root {\n    overflow: hidden;\n    font-family: 'Manrope';\n    background: #EEE !important;\n}\n/*#navbarToggle {*/\n/*    background-color: #EFEFEF;*/\n/*}*/\n.white, .white a {\n    color: #fff;\n}\n.page-content {\n    overflow: hidden;\n    background-color: #EFEFEF;\n    font-family: 'Manrope';\n}\n#page .navbar {\n    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.512715) 61.57%, rgba(255, 255, 255, 0) 100%) !important;\n    --bs-navbar-padding-x: 0 !important;\n}\n\n.main {\n  height: 92vh!important;\n  width: 100vw;\n  overflow: hidden;\n  position: relative;\n}\n.main-container {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n    filter: blur(64px);\n    -webkit-filter: blur(64px);\n\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    transform: scale(1.1);\n}\n.main .face1 {\n  background-image: url(\"./images/home-bg1.png\");\n}\n.main .face2 {\n  background-image: url(\"./images/home-bg2.png\");\n}\n.main .face3 {\n  background-image: url(\"./images/home-bg3.png\");\n}\n.effect-bg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(180deg, rgba(252, 137, 118, 0.25) 0%, rgba(242, 67, 136, 0.25) 100%);\n    mix-blend-mode: overlay;\n}\n\n.face1, .face2, .face3 {\n  -webkit-transition: opacity 1s ease-in-out;\n  -moz-transition: opacity 1s ease-in-out;\n  -o-transition: opacity 1s ease-in-out;\n  transition: opacity 1s ease-in-out;\n\n}\n\n@-webkit-keyframes faceFadeInOut {\n  0% {opacity: 0;}\n  20% {opacity: 1;}\n  33% {opacity: 1;}\n  53% {opacity: 0;}\n  100% {opacity: 0;}\n}\n@keyframes faceFadeInOut {\n 0% {opacity: 0;}\n 20% {opacity: 1;}\n 33% {opacity: 1;}\n 53% {opacity: 0;}\n 100% {opacity: 0;}\n}\n\n.face1,.face2,.face3 {\n -webkit-animation: faceFadeInOut 24s infinite;\n  animation: faceFadeInOut 9s infinite;\n}\n.face1 {\n    animation-delay: 0s;\n    opacity:1;\n}\n.face2 {\n    animation-delay: 3s;\n    opacity:0;\n}\n.face3 {\n    animation-delay: 6s;\n    opacity:0;\n}\n\n.face1-container {\n   background-image: url(\"./images/face1.png\");\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n   z-index: 1;\n}\n.face2-container {\n   background-image: url(\"./images/face2.png\");\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n   z-index: 1;\n}\n.face3-container {\n   background-image: url(\"./images/face3.png\");\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n   z-index: 1;\n}\n.find-container{\n    z-index: 2;\n}\n.find-container input {\n    border-radius: 2rem;\n    padding: 15px;\n}\n\n.arrow-container .left-label, .arrow-container .right-label{\n    position: absolute;\n    height: 1px;\n\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 148%;\n    /* or 18px */\n    display: flex;\n    align-items: center;\n    text-align: right;\n    letter-spacing: 0.02em;\n    color: #FFFFFF;\n    z-index: 2;\n}\n.arrow-container .left-label {\n    right:10px;\n}\n.arrow-container .right-label {\n    left: 20px;\n    width: 100px;\n}\n.arrow-container .mid-arrow {\n   display: block;\n   height: 2px;\n   background-image: url(\"./images/midarrow.png\");\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n}\n.arrow-container .left-arrow {\n   display: block;\n   width:25px;\n  height:25px;\n   background-image: url(\"./images/leftarrow.png\");\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n}\n.arrow-container .right-arrow {\n   display: block;\n   width:25px;\n   height:25px;\n   background-image: url(\"./images/rightarrow.png\");\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n}\n\n.home-title {\n\n    font-style: normal;\n    text-align: center;\n    letter-spacing: -0.02em;\n    text-transform: lowercase;\n    color: #FFFFFF;\n}\n.navbar {\n   --bs-border-radius: 2rem;\n    --bs-navbar-padding-x: 1.5rem!important;\n    --bs-navbar-padding-y: 1.5rem!important;\n    z-index:10;\n}\n.navbar .navbar-brand {\n\n    font-style: normal;\n    font-weight: 800;\n    font-size: 20px;\n    line-height: 125%;\n    /* or 25px */\n\n    letter-spacing: 0.01em;\n    text-transform: lowercase;\n\n    /* Dark */\n\n    color: #2C262F;\n}\n.navbar .navbar-nav li {\n    padding: 0 35px;\n\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 148%;\n\n    text-transform: lowercase;\n\n    /* Inside auto layout */\n    flex: none;\n    order: 2;\n    flex-grow: 0;\n}\n.navbar .navbar-collapse {\n    flex-basis: 50%;\n}\n.about .faceless .title {\n    font-style: normal;\n    color: #FF855E;\n}\n.about .about-msg {\n\n    font-style: normal;\n    margin-bottom: 50px;\n    color: #4A444C;\n}\n.about .ico {\n    width: 32px;\n    height: 32px;\n}\n.about .figure {\n    width: 200px;\n    height: 240px;\n    position: relative;\n}\n.about .figure .illustration {\n    position: absolute;\n    width: 120px;\n    height: 120px;\n    left: 80px;\n    top: 0px;\n}\n.about .figure .label {\n    position: absolute;\n    width: 182px;\n    height: 36px;\n    left: 20px;\n    top: 168px;\n    display: inline-block;\n\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 148%;\n    letter-spacing: 0.02em;\n    color: #4A444C;\n}\n\n.about .figures {\n    display: inline;\n}\n.about .hireworkers {\npadding-top:25px;\n}\n.about .hireworkers .title {\n    font-style: normal;\n    color: #2C262F;\n    margin-bottom: 40px;\n}\n.about .hireworkers .desc {\n    font-style: normal;\n    color: #4A444C;\n    width: 264px;\n    height: 300px;\n}\n.about .hireworkers .desc .br{\n    height:40px;\n}\n\n.arrow2-container {\n    margin-left: auto;\n    margin-right: auto;\n}\n.arrow2-container .left-label2, .arrow2-container .right-label2{\n    position: absolute;\n    height: 1px;\n    display: flex;\n    align-items: center;\n    text-align: right;\n    letter-spacing: 0.02em;\n    color: #FFFFFF;\n}\n\n.arrow2-container .mid-arrow2 {\n   display: block;\n   height: 2px;\n   background-image: url(\"./images/midarrow2.png\");\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n   margin-top: 1px;\n}\n.arrow2-container .left-arrow2 {\n   display: block;\n   width:25px;\n   height:25px;\n   background-image: url(\"./images/leftarrow2.png\");\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n}\n.arrow2-container .right-arrow2 {\n   display: block;\n   width:25px;\n   height:24px;\n   background-image: url(\"./images/rightarrow2.png\");\n   background-position: center;\n   background-repeat: no-repeat;\n   background-size: cover;\n}\n.arrow2-container img {\n    width: 53.42px;\n    height: 48px;\n}\n\n.about .recommendation {\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-image: linear-gradient(0deg, rgba(44, 38, 47, 0.8), rgba(44, 38, 47, 0.8)),  url(\"./images/recommendation-bg.png\");\n    color: #FFFFFF;\n}\n.about .recommendation .desc {\n    font-style: normal;\n    margin-top: 25px;\n    margin-bottom: 25px;\n}\n.about .recommendation .desc .br{\n    height:40px;\n}\n.about .recommendation .form{\n    background: #FFFFFF;\n    border-radius: 40px;\n}\n.about .recommendation .form .title{\n    color: #2C262F;\n}\n.about .join .form .title{\n    color: #2C262F;\n}\n.about .join .links a{\n    text-transform: lowercase;\n    color: #4A444C;\n    text-decoration: none;\n    overflow: hidden;\n}\n.about .social-link img{\n   border-radius: 80px;\n   height: 48px;\n   width: 48px;\n}\n\n@import \"./scss/components.css\";\n\n@import \"./scss/media_width_200.css\";\n@import \"./scss/media_width_390.css\";\n@import \"./scss/media_width_768.css\";\n@import \"./scss/media_width_1024.css\";\n@import \"./scss/media_width_1300.css\";\n@import \"./scss/media_height_200.css\";\n@import \"./scss/media_height_500.css\";\n@import \"./scss/media_height_720.css\";\n@import \"./scss/media_height_1024.css\";\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
